import React from 'react';
import { MsgBox } from '../custom-ant-d'

export const GlobalApiErrorHandler = (props) => {
  const { errors } = props;

  var errorMessage = "";

  try {
    for (const [key, value] of Object.entries(errors)) {
      errorMessage = errorMessage + "\n" + value[0]
    }
    return MsgBox({
      type: 'error',
      message: 'Api Error!',
      description: errorMessage
    });

  } catch {
    return MsgBox({
      type: 'error',
      message: 'Api Error!',
      description: 'Something went wrong on the request'
    });
  }
}
